<template>
  <div id="container-popover">
    <div class="v-popover-tag">
      <slot></slot>
    </div>
    <div
      class="v-popover-wrap"
      v-show="show"
      id="popover-wrap"
      :style="{ left: x + 'px', top: y + 'px', width: width + 'px' }"
      ref="pop"
    >
      <div class="v-popover-content">
        <span class="persionBodyPart-risk">{{ riskLevelName }}</span>
        <div
          class="persionBodyPart-risk-item"
          v-if="data.riskFactorList && data.riskFactorList.length"
        >
          <span class="persionBodyPart-risk-item-name">{{ riskString }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "poperView",
  props: {
    riskLevelName: {
      type: String,
      default: "风险未知",
    },
    index: {
      type: Number,
      default: -1,
    },
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    placement: {
      type: String,
      default: "top",
    },
    arrow: {
      type: String,
      default: "left",
    },
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      arrowLeft: 0,
      arrowTop: 0,
      x: 0,
      y: 0,
      width: 0,
      lastTarget: null,
      lastX: 0,
      lastHeight: 0,
      riskString: "",
    };
  },
  created() {},
  watch: {
    show(val) {
      // console.log(val);
    },
    data(val) {
      // console.log(val);
      let riskArray = [];
      this.data.riskFactorList.forEach((item) => {
        riskArray.push(item.riskFactorName);
      });
      this.riskString = riskArray.join(" | ");
      // if (!this.lastTarget) {
      //   return;
      // }
      // let e = this.lastTarget;
      // var target = e.currentTarget;
      // console.log(target);
      // this.width = 160;
      // if (this.arrow == "left") {
      //   this.x = target.offsetWidth + 10;
      //   // this.arrowLeft = target.offsetWidth / 2;
      // } else {
      //   this.x =  - (this.width + 10);
      //   // this.arrowLeft =
      //   //   this.width - target.offsetWidth + target.offsetWidth / 2;
      // }
      // this.$nextTick(()=>{
      //   // let containerProgress = document.getElementById('popover-wrap');
      //   // console.log(containerProgress);
      //   let container = this.$refs.pop.getBoundingClientRect();
      //   this.y = -container.width/2;
      //   console.log(container);
      // });
      this.$nextTick(() => {
        // let containerProgress = document.getElementById('popover-wrap');
        // console.log(containerProgress);
        this.x = this.lastX;
        let container = this.$refs.pop.getBoundingClientRect();
        this.y = -(container.height / 2 - this.lastHeight / 2);
        // this.y = 0;
        // console.log(container.height);
      });
    },
  },
  methods: {
    pop(e) {
      // if (this.riskLevelName == "风险未知") {
      //   return ;
      // }
      // if (!this.list.length) {
      //   return;
      // }

      // if (this.show) {
      //   this.$emit("closePopover", false, this.index);
      //   return;
      // }
      // this.$emit("closePopover", !this.show, this.index);
      this.$emit("getData", !this.show, this.index);

      this.lastTarget = e;

      // console.log(e);

      var target = e.currentTarget;
      // console.log(target);
      this.width = 160;
      this.lastHeight = target.offsetHeight;
      if (this.arrow == "left") {
        this.lastX = target.offsetWidth + 10;
        // this.arrowLeft = target.offsetWidth / 2;
      } else {
        this.lastX = -(this.width + 10);
        // this.arrowLeft =
        //   this.width - target.offsetWidth + target.offsetWidth / 2;
      }

      // this.y = target.offsetHeight/2 -100;

      // // console.log(this.x);
      // if (this.placement == "top") {
      //   // console.log(111);
      //   this.arrowTop = this.$refs.pop.offsetHeight;
      //   // console.log(this.arrowTop);
      //   this.y =
      //     target.offsetTop -
      //     (this.list.length * 20 + 9 * 2) -
      //     6;
      // } else {
      //   // console.log(222);
      //   this.arrowTop = -3;
      //   this.y =
      //     target.offsetTop + target.offsetHeight + 6;
      // }
    },
  },
};
</script>

<style scoped>
#container-popover {
  /* background-color: aquamarine; */
  box-sizing: border-box;
  position: absolute;
}

.v-popover-tag {
}
.v-popover-wrap {
  position: absolute;
  z-index: 100;
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.13);
  overflow: hidden;
  background-color: transparent;
  border: royalblue 1px solid;
  /* min-height: 200px; */
}
.v-popover-content {
  /* max-height: 200px; */
  padding: 10px;
  /* overflow: scroll; */
}

/* .v-popover-content .item {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #535353;
  position: relative;
}
.v-popover-content .item .name {
  display: inline-block;
  width: 60%;
  text-align: left;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-popover-content .item .risk {
  display: inline-block;
  width: 35%;
  text-align: right;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
} */

.persionBodyPart-risk {
  display: inline-block;
  /* text-align: center; */
  font-size: 16px;
  width: 100%;
  color: #fff;
  /* padding-bottom: 10px; */
}

.persionBodyPart-risk-item {
  border-top: #fff solid 1px;
  margin-top: 10px;
}

.persionBodyPart-risk-item-name {
  display: inline-block;
  /* text-align: center; */
  font-size: 14px;
  width: 100%;
  color: #fff;
  padding-top: 10px;
}

.v-popover-arrow-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-color: transparent transparent #6692ff transparent;
  border-style: solid;
  border-width: 0px 10px 15px 10px;
  z-index: 2;
}

.v-popover-arrow-bottom {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-color: #fff transparent transparent transparent;
  border-style: solid;
  border-width: 15px 10px 0 10px;
  z-index: 2;
}
</style>
